import { Routes } from '@angular/router';
import {publicRoutes} from './public/public.routes';
import { secureRoutes } from './secure/secure.routes';
import { AuthGuard } from './core/_guards/auth.guards';
import { SpinnerComponent } from './core/spinner/spinner.component';

export const routes: Routes = [

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'spinner',
        
    },
    {
        path: 'spinner',
        component: SpinnerComponent,
        canActivate: [AuthGuard],
      
    },
    ...publicRoutes,
    ...secureRoutes,
    {
        path: '**',
        redirectTo: 'public/login',
    }
    
];
